import React from "react";
import { NumberBox, Validator } from "devextreme-react";

class NumberField extends React.PureComponent {
  handleValidation = (e) => {
    if (this.props.customValidation) this.props.customValidation(e)
    else {
      if (e.value != null && e.value !== NaN && e.value >= this.props.min) return true;
    }

    return false
  }

  render() {
    const {
      label,
      disabled,
      value,
      onChange,
      id,
      optional,
      skipValidation,
      max,
      min,
      required,
      customValidation,
      showSpinButtons,
      skipParse,
      ...rest
    } = this.props;

    return (
      <div className="field-newDenuncia" style={{ marginLeft: optional ? 20 : 0 }}>
        {label && <h3><p>{label}{required ? <span className="label-red-requerido"> *</span> : ""}</p></h3>}
        {id && id === "telefono"
          ? <div style={{display: "flex", alignItems: "center", justifyContent: "end"}}>
              <span style={{marginRight: "5px"}}>+56</span>
              <NumberBox
                disabled={disabled}
                value={!skipParse ? parseInt(value, 10) : value}
                onValueChanged={onChange}
                showSpinButtons={showSpinButtons}
                max={max}
                min={min}
                id={id}
                {...rest}
                style={{width: "100%"}}
              >
                <Validator

                  validationRules={
                    !skipValidation ? [{
                      type: "custom",
                      message: "Este campo es requerido",
                      validationCallback: this.handleValidation,
                    }] : []}
                />
              </NumberBox>
            </div>
          : <NumberBox
              disabled={disabled}
              value={!skipParse ? parseInt(value, 10) : value}
              onValueChanged={onChange}
              showSpinButtons={showSpinButtons}
              max={max}
              min={min}
              id={id}
              {...rest}
              style={{width: "100%"}}
            >
              <Validator

                validationRules={
                  !skipValidation ? [{
                    type: "custom",
                    message: "Este campo es requerido",
                    validationCallback: this.handleValidation,
                  }] : []}
              />
            </NumberBox>
        }
      </div>
    );
  }
}

export default NumberField;
